import { h } from "preact";
import styled from "styled-components";
import QRCode from "react-qr-code";

export interface BarCodeProp {
	content: string;
	width: number;
	height: number;
	id: string;
	text?: string;
}

const CodeWrapper =
	styled.div <
		{ width: number, height: number } >
		`
			display: flex;
			flex-direction: column;
			background-color: white;
			width: ${(props) => props.width}px;
			height:  ${(props) => props.height}px;
			justify-content: space-between;
		`;

const CodeLabel = styled.div`
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	letter-spacing: 0.03em;
	color: #000000;
`;

export const QR = ({ content, width, height, id, text }: BarCodeProp) => {
	return (
		<CodeWrapper width={width} height={height}>
			{text &&(
				<CodeLabel>{text}</CodeLabel>
			)}
			<QRCode id={id} value={content} size={width} />
			<CodeLabel>ID {content}</CodeLabel>
		</CodeWrapper>
	);
};
